import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { CustomNamesService } from '../services/custom-names.service';
import { CodeName } from '../types';

@Pipe({
  name: 'customNames',
})
export class CustomNamesPipe implements PipeTransform {
  private readonly customNamesService = inject(CustomNamesService);
  private readonly translateService = inject(TranslateService);

  transform(codeName: CodeName): string {
    return this.customNamesService.getItem(codeName)?.title ?? this.translateService.instant('common.labels.noData');
  }
}
